export default __webpack_public_path__ + "static/media/_applied.9ffac247.png";